<template>
  <div class="error-text">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'ErrorField',
  props: {
    errors: {
      type: Object,
      default: null,
    },
    field: {
      type: String,
      default: null,
    },
  },
  computed: {
    message() {
      if (this.errors.has(this.field)) {
        return this.errors.get(this.field);
      }
      return '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ErrorField.vue